// Domain Events - Central export point for all domain events
// These events represent business-significant occurrences in the invoice system

// Base event types
export type { DomainEvent, DomainEventType } from "./DomainEvent";
export { DomainEventSchema } from "./DomainEvent";

// Invoice lifecycle events
export type { InvoiceCreated, InvoiceCreatedType } from "./InvoiceCreated";
export { InvoiceCreatedSchema } from "./InvoiceCreated";

export type {
  InvoiceDraftRequested,
  InvoiceDraftRequestedType,
  InvoiceCreationFailedType,
} from "./InvoiceEvents";
export {
  InvoiceDraftRequestedSchema,
  InvoiceCreationFailedSchema,
} from "./InvoiceEvents";

// Storage-related events
export type {
  InvoicePDFUploaded,
  InvoicePDFUploadedType,
  InvoicePDFUploadFailedType,
} from "./StorageEvents";
export {
  InvoicePDFUploadedSchema,
  InvoicePDFUploadFailedSchema,
} from "./StorageEvents";

// Import types for union type
import type { InvoiceCreated } from "./InvoiceCreated";
import type { InvoiceDraftRequested } from "./InvoiceEvents";
import type {
  InvoicePDFUploaded,
  InvoicePDFUploadFailedType,
} from "./StorageEvents";

// Union type of all domain events for type safety
export type AllDomainEvents =
  | InvoiceCreated
  | InvoiceDraftRequested
  | InvoicePDFUploaded
  | InvoicePDFUploadFailedType;

// Event type constants for filtering and routing
export const EventTypes = {
  INVOICE_CREATED: "InvoiceCreated" as const,
  INVOICE_DRAFT_REQUESTED: "InvoiceDraftRequested" as const,
  INVOICE_CREATION_FAILED: "InvoiceCreationFailed" as const,
  INVOICE_PDF_UPLOADED: "InvoicePDFUploaded" as const,
  INVOICE_PDF_UPLOAD_FAILED: "InvoicePDFUploadFailed" as const,
} as const;

// Event categories for grouping and filtering
export const EventCategories = {
  INVOICE_LIFECYCLE: [
    EventTypes.INVOICE_CREATED,
    EventTypes.INVOICE_DRAFT_REQUESTED,
    EventTypes.INVOICE_CREATION_FAILED,
  ],
  STORAGE_OPERATIONS: [
    EventTypes.INVOICE_PDF_UPLOADED,
    EventTypes.INVOICE_PDF_UPLOAD_FAILED,
  ],
} as const;
